<template>
  <md-card>
    <md-card-content>
      <h3 class="h3">
        Platform Payment
      </h3>
      <md-progress-bar
        v-if="loading"
        md-mode="indeterminate"
      />
      <form
        v-else
        class="node-form"
      >
        <md-field :class="$v.platform_payment_product_id.$error && 'md-invalid invalid-field'">
          <label>Platform Payment Product ID</label>
          <md-input v-model="platform_payment_product_id" />
          <span class="md-error">Required field</span>
        </md-field>
        <md-field :class="$v.name.$error && 'md-invalid invalid-field'">
          <label>Name</label>
          <md-input v-model="name" />
          <span class="md-error">Required field</span>
        </md-field>
        <md-field :class="$v.description.$error && 'md-invalid invalid-field'">
          <label>Description</label>
          <md-textarea v-model="description" />
          <span class="md-error">Required field</span>
        </md-field>
      </form>
    </md-card-content>

    <md-card-actions :style="{ justifyContent: isCreateMode ? 'flex-end' : 'space-between' }">
      <md-button
        v-if="!isCreateMode"
        type="submit"
        class="md-primary delete-button"
        @click.native="deletePaymentData"
      >
        <span v-if="!loadingDelete">Delete</span>
        <md-progress-spinner
          v-else
          :md-diameter="15"
          :md-stroke="3"
          md-mode="indeterminate"
        />
      </md-button>

      <md-button
        type="submit"
        class="md-primary"
        @click.native="submitPaymentData"
      >
        <span v-if="!loadingSubmission">Save</span>
        <md-progress-spinner
          v-else
          :md-diameter="15"
          :md-stroke="3"
          md-mode="indeterminate"
        />
      </md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
        name: "PlatformPaymentForm",
        props: { productId: { type: String, required: true } },
        data(){
            return {
                name: "",
                description: "",
                platform_payment_product_id: "",

                loading: true,
                loadingSubmission: false,
                loadingDelete: false,
                isCreateMode: true
            };
        },
        mounted() {
            this.fetchPaymentData();
        },
        methods: {
            fetchPaymentData() {
                this.$http.get(`/v1/admin/store/platform-payment-integration/${this.productId}`)
                    .then(res => {
                        this.name = res.data.name;
                        this.description = res.data.description;
                        this.platform_payment_product_id = res.data.platform_payment_product_id;

                        this.isCreateMode = false;

                        this.loading = false;
                    })
                    .catch(() => {
                        this.isCreateMode = true;
                        this.loading = false;
                    });
            },
            submitPaymentData() {
                this.$v.$touch();

                if (this.$v.$error) {
                    return;
                }

                this.loadingSubmission = true;

                const method = this.isCreateMode ? "post" : "put";

                this.$http[method]("/v1/admin/store/platform-payment-integration", {
                    product_id: this.productId,
                    platform_payment_product_id: this.platform_payment_product_id,
                    name: this.name,
                    description: this.description
                })
                    .then(() => {
                        this.loadingSubmission = false;
                    });
            },
            deletePaymentData() {
                this.loadingDelete = true;

                this.$http.delete(`/v1/admin/store/platform-payment-integration/${this.productId}`)
                    .then(() => {
                        this.name = "";
                        this.description = "";
                        this.platform_payment_product_id = "";

                        this.isCreateMode = true;
                        this.loadingDelete = false;
                    });
            }
        },
        validations: {
            platform_payment_product_id: {required},
            name: {required},
            description: {required}
        }
    };
</script>

<style scoped lang="scss">
    .delete-button {
        background-color: red !important;
    }
</style>
